import React from "react"

const MobileMenuButton = props => {

	return (
		<div className="body__mobileClose">
			<i className="fas fa-bars"></i>
		</div>
	)
}

export default MobileMenuButton
